/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {getNotificationStore, useNotificationStore} from "./stores/NotificationStore.js";

const Notification = function () {

    function createError(title, text = '', uiElementId = '') {
        return getNotificationStore().createError(title, text, uiElementId);
    }

    function createWarning(title, text = '', uiElementId = '') {
        return getNotificationStore().createWarning(title, text, uiElementId);
    }

    function createInfo(title, text = '', uiElementId = '') {
        return getNotificationStore().createInfo(title, text, uiElementId);
    }

    function markRead(messageId) {
        getNotificationStore().markRead(messageId);
    }

    function getAll() {
        return getNotificationStore().getAll();
    }

    function clear(uiElementId) {
        getNotificationStore().clear(uiElementId);
    }

    function onChange(callback) {
        return useNotificationStore.subscribe(() => {
            callback();
        });
    }

    return {
        createError: createError,
        createWarning: createWarning,
        createInfo: createInfo,
        markRead: markRead,
        getAll: getAll,
        onChange: onChange,
        clear: clear
    }

}()

export {Notification};